import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const connectBaseUrl = `${environment.apis.connect}/${globals.DATASETS}`;
const cdsBaseUrl = `${environment.apis.cds}/${globals.DATASETS}`;

@Injectable({
  providedIn: 'root',
})

export class DatasetsService {
  constructor(
    private http: HttpClient) { }

  get_datasets(): Observable<any> {
    return this.http.get<any>(`${connectBaseUrl}/${globals.GET_DATASETS}`);
  }
  
  addOrUpdate(data: any): Observable<boolean> {
    return this.http.post<boolean>(`${connectBaseUrl}/${globals.ADD_OR_UPDATE}`, data);
  }
  
  delete_dataset(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${connectBaseUrl}/${globals.DELETE_DATASET}/${id}`);
  }
  
  delete_dataset_file(file_name: string): Observable<boolean> {
    return this.http.delete<boolean>(`${cdsBaseUrl}/${globals.DATASET_DELETE}/${file_name}`);
  }

  dataset_upload(data: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${cdsBaseUrl}/${globals.DATASET_UPLOAD}`, data);
  }

  dataset_download(file_name: string): Observable<any> {
    return this.http.get(`${cdsBaseUrl}/${globals.DATASET_DOWNLOAD}?file_name=${file_name}`, { responseType: 'blob' });
  }

}
